@if (form) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="text-[14px]">
    
    <div class="mb-4">
      <h6 class="text-[14px] font-semibold text-slate-900" i18n>
        {{ "change" | transloco }} {{ "password" | transloco }}
      </h6>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-3 items-end">
      
      @if (!isReset) {
        <div [appValidateState]="form.get('currentPassword')" class="flex flex-col gap-1.5">
          <label for="currentPassword" class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium select-none" i18n="Current password">
            {{ "current" | transloco }} {{ "password" | transloco }}
          </label>
          <input
            id="currentPassword"
            formControlName="currentPassword"
            type="password"
            class="w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/15 focus:border-[var(--primary-color)]/50 transition-all"
            placeholder="{{ 'current' | transloco }} {{ 'password' | transloco }}"
            i18n-placeholder="Current password"
            required
          />
        </div>
      }

      <div [appValidateState]="form.get('password')" class="flex flex-col gap-1.5">
        <label for="password" class="flex items-center gap-1.5 text-[12px] uppercase tracking-[0.12em] text-slate-500 font-medium select-none" i18n="New password">
          {{ "new" | transloco }} {{ "password" | transloco }}
        </label>
        <input
          id="password"
          formControlName="password"
          type="password"
          class="w-full px-[10px] py-2 rounded-lg border border-slate-200/80 bg-white text-[14px] text-slate-800 placeholder:text-slate-400 focus:outline-none transition-all"
          placeholder="{{ 'new' | transloco }} {{ 'password' | transloco }}"
          i18n-placeholder="New password"
          required
        />
      </div>

      <div class="w-full">
        <button 
          type="submit" 
          class="w-full px-5 py-2 bg-[var(--primary-color)] text-white text-[14px] font-medium rounded-lg shadow-sm transition-all cursor-pointer h-[38px] flex items-center justify-center border border-none" 
          i18n="@@update"
        >
          {{ "update" | transloco }}
        </button>
      </div>

    </div>
  </form>
}